import { TableCellNode } from "@lexical/table";
import SettingsIcon from "@mui/icons-material/Settings";
import { Button, Popover } from "@mui/material";
import type { FC } from "react";
import { usePopover } from "../../../../../utils/hooks/use-popover";
import type { DataTableCellNode } from "../../nodes/data-table-cell-node";
import { $isDataTableCellNode } from "../../nodes/data-table-cell-node";
import { StylableTableCellMui } from "../../nodes/stylable-table-cell-mui";
import { DataTablePopoverMenu } from "./data-table-popover-menu";
import { TableColumnPopoverMenu } from "./table-column-popover-menu";

export const TableColumnPopoverMenuButton: FC<{
  tableCellNode: TableCellNode | StylableTableCellMui | DataTableCellNode;
}> = ({ tableCellNode }) => {
  const { anchorRef, handleOpen, handleClose, open } = usePopover<HTMLButtonElement>();

  return (
    <>
      <Button
        data-analytics-id="lexical-table-menu-button"
        ref={anchorRef}
        onClick={handleOpen}
        size="small"
        variant="contained"
        sx={{
          minWidth: "unset",
          paddingX: 1,
          paddingY: 0.5,
          borderRadius: 0.5,
        }}
      >
        <SettingsIcon sx={{ fontSize: "small" }} />
      </Button>
      {/* eslint-disable-next-line react-hooks/refs */}
      <Popover anchorEl={anchorRef.current} open={open} onClose={handleClose}>
        {$isDataTableCellNode(tableCellNode) ? (
          <DataTablePopoverMenu tableCellNode={tableCellNode} onClick={handleClose} />
        ) : (
          <TableColumnPopoverMenu tableCellNode={tableCellNode} onClick={handleClose} />
        )}
      </Popover>
    </>
  );
};
